import { render, staticRenderFns } from "./view_file.vue?vue&type=template&id=5fbc733d&scoped=true"
import script from "./view_file.vue?vue&type=script&lang=js"
export * from "./view_file.vue?vue&type=script&lang=js"
import style0 from "./view_file.vue?vue&type=style&index=0&id=5fbc733d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc733d",
  null
  
)

export default component.exports